import {useSelector} from 'react-redux';
import {wideScreen} from '../globalVariables/GlobalVariables';

const useWideScreen = () => {
    return useSelector(s => s.ui.windowWidth < wideScreen);
};

export default useWideScreen;

